import characters from '../assets/json/characters.json'

export const getCharacters = () => {
    return characters
}
